// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationSuccessCheckCircle: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#006638", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 18 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M9 1.375a7.875 7.875 0 1 1 0 15.75 7.875 7.875 0 0 1 0-15.75M9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18m3.772-10.853a.564.564 0 0 0 0-.794.564.564 0 0 0-.794 0l-4.103 4.102-1.853-1.852a.564.564 0 0 0-.794 0 .564.564 0 0 0 0 .794l2.25 2.25a.564.564 0 0 0 .794 0z"
            />
        </svg>
    );
};

export default React.memo(NotificationSuccessCheckCircle);
